import { AbstractSummary } from "./abstractSummary";


export class CampaignSummary extends AbstractSummary {
    additionalPrintingPrice: number;
    additionalMountingPrice: number;
}
